jQuery(document).ready(function onStartpageReady() {
    "use strict";

    var $startpage = jQuery('.start-page');

    if($startpage.length === 0) {
        return;
    }

    new Swiper('.swiper-container', {
        autoHeight: true,
        pagination: {
            el: '.swiper-pagination'
        },
        autoplay: {
            delay: 10000
        }
    });
});

